module.exports = __webpack_public_path__ + "img/login-bg.ecb0d8de.jpg";